// Display only stored dates; never reconstruct Welcome/Referral deadlines
// from today's configuration or from registration/assignment timestamps.
export function customerPromoExpiry(p, now = new Date()) {
  const rawEnds = [p.effective_ends_at, p.ends_at, p.assoc_valid_until]
    .filter(value => value != null && value !== "");
  const ends = rawEnds.map(value => new Date(value));
  const expired = p.assoc_status === "expired" || p.unavailable_reason === "expired" ||
    (typeof p.days_left === "number" && p.days_left <= 0);
  if (ends.some(date => !Number.isFinite(date.getTime()))) return "";
  if (ends.length) {
    const end = new Date(Math.min(...ends.map(date => date.getTime())));
    const label = expired || end.getTime() <= now.getTime() ? "Scaduta il" : "Scade il";
    return `${label} ${end.toLocaleDateString("it-IT", {
      day: "2-digit", month: "2-digit", year: "numeric",
    })}`;
  }
  if (expired || p.lost_unused || p.unavailable_reason || p.available_for_user !== true) return "";
  return "Senza scadenza";
}
